export const commonInlineTagNames: ReadonlyArray<string> = ["A", "ABBR", "B", "CITE", "EM", "FONT", "I", "MARK", "Q", "S", "SMALL", "SPAN", "STRIKE", "STRONG", "SUB", "SUP", "TIME", "U"];
